import React, {useState, useEffect} from 'react';
import {ContentWrapper, Button, Input, SelectType} from '@components';
import DeleteIcon from '../../assets/images/delete.png';
import {getShopUsers, sendNotification} from '@apis';
import Multiselect from 'multiselect-react-dropdown';
import {toast} from 'react-hot-toast';
import {useTranslation} from 'react-i18next';

const notificationTypes = [
  {label: 'Off', value: 'off'},
  {label: 'SMS', value: 'sms'},
  {label: 'Push', value: 'push'},
  {label: 'All', value: 'all'},
];

const Marketing = () => {
  const {t} = useTranslation();
  const [selectedType, setSelectedType] = useState(notificationTypes[0].value);
  const [users, setUsers] = useState([]);
  const [shopUsers, setShopUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [data, setData] = useState({
    users: [],
    custom_title_en: '',
    custom_title_es_mx: '',
    custom_body_en: '',
    custom_body_es_mx: '',
    notification_type: 'off',
  });

  const handleTypeSelection = item => {
    setSelectedType(item);
    setData({...data, notification_type: item});
  };

  const fetchData = async () => {
    const resp = await getShopUsers();
    setUsers(resp.results);

    var array = [];
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    var users_array = [];
    users.forEach(function(item, index) {
      users_array.push({
        name: item.user.first_name + ' ' + item.user.first_name,
        id: item.user.id,
      });
    });
    setShopUsers(users_array);
  }, [users]);

  const onSelectUser = (selectedList, selectedItem) => {
    selectedUsers.indexOf(selectedItem.id) === -1
      ? setData({...data, users: [...data.users, selectedItem.id]})
      : console.log('This item already exists');
  };

  const onRemoveUser = (selectedList, removedItem) => {
    var array = [...data.users];
    var index = array.indexOf(removedItem.id);
    if (index !== -1) {
      array.splice(index, 1);
      setData({...data, users: array});
    }
  };

  const sendNotif = () => {
    // Validate that both English and Spanish fields are filled
    if (
      !data.custom_title_en ||
      !data.custom_title_es_mx ||
      !data.custom_body_en ||
      !data.custom_body_es_mx
    ) {
      toast.error('Both English and Spanish fields are required');
      return;
    }

    if (data.users.length === 0) {
      toast.error('Please select at least one user');
      return;
    }

    sendNotification(data)
      .then(() => {
        toast.success(t('marketing.notificationSent'));
        // Reset form after successful send
        setData({
          users: [],
          custom_title_en: '',
          custom_title_es_mx: '',
          custom_body_en: '',
          custom_body_es_mx: '',
          notification_type: 'off',
        });
      })
      .catch(e => {
        toast.error(e);
      });
  };

  return (
    <ContentWrapper
      breadcrumb={[
        {title: t('sidebar.menuItems.marketing'), link: '/marketing'},
      ]}
      hasSearch={false}>
      <div>
        <div className="bg-tableHeaderBg rounded">
          <p className="uppercase text-sm px-4 py-3 text-menu">
            {t('marketing.notificationSettings')}{' '}
            <span style={{marginLeft: '25%', color: '#B5B5C3'}}>
              {t('marketing.sendUsing')}
            </span>{' '}
            <span style={{marginLeft: '25%', color: '#B5B5C3'}}>
              {t('marketing.notification')}
            </span>
          </p>
        </div>

        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow" style={{maxWidth: '30%'}}>
            {t('marketing.newProducts')}
          </div>
          <div className="" style={{marginRight: 10}}>
            <SelectType
              items={notificationTypes}
              onSelect={handleTypeSelection}
              selected={selectedType}
            />
          </div>
          <div className="flex-grow" style={{marginRight: 10}}>
            <Input
              placeholder={t('marketing.enterNotificationTitle')}
              value={data.custom_title_en || ''}
              onChange={e =>
                setData({...data, custom_title_en: e.target.value})
              }
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow" style={{maxWidth: '30%'}}>
            {t('marketing.productDiscount')}
          </div>
          <div className="" style={{marginRight: 10}}>
            <SelectType
              items={notificationTypes}
              onSelect={handleTypeSelection}
              selected={selectedType}
            />
          </div>
          <div className="flex-grow" style={{marginRight: 10}}>
            <Input
              placeholder={t('marketing.enterNotificationTitle')}
              value={data.custom_title_en || ''}
              onChange={e =>
                setData({...data, custom_title_en: e.target.value})
              }
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow" style={{maxWidth: '30%'}}>
            {t('marketing.pointsAdded')}
          </div>
          <div className="" style={{marginRight: 10}}>
            <SelectType
              items={notificationTypes}
              onSelect={handleTypeSelection}
              selected={selectedType}
            />
          </div>
          <div className="flex-grow" style={{marginRight: 10}}>
            <Input
              placeholder={t('marketing.enterNotificationTitle')}
              value={data.custom_title_en || ''}
              onChange={e =>
                setData({...data, custom_title_en: e.target.value})
              }
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow" style={{maxWidth: '30%'}}>
            {t('marketing.redeemRequestApproved')}
          </div>
          <div className="" style={{marginRight: 10}}>
            <SelectType
              items={notificationTypes}
              onSelect={handleTypeSelection}
              selected={selectedType}
            />
          </div>
          <div className="flex-grow" style={{marginRight: 10}}>
            <Input
              placeholder={t('marketing.enterNotificationTitle')}
              value={data.custom_title_en || ''}
              onChange={e =>
                setData({...data, custom_title_en: e.target.value})
              }
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow" style={{maxWidth: '30%'}}>
            {t('marketing.useRewardPoints')}
          </div>
          <div className="" style={{marginRight: 10}}>
            <SelectType
              items={notificationTypes}
              onSelect={handleTypeSelection}
              selected={selectedType}
            />
          </div>
          <div className="flex-grow" style={{marginRight: 10}}>
            <Input
              placeholder={t('marketing.enterNotificationTitle')}
              value={data.custom_title_en || ''}
              onChange={e =>
                setData({...data, custom_title_en: e.target.value})
              }
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow" style={{maxWidth: '30%'}}>
            {t('marketing.birthday')}
          </div>
          <div className="" style={{marginRight: 10}}>
            <SelectType
              items={notificationTypes}
              onSelect={handleTypeSelection}
              selected={selectedType}
            />
          </div>
          <div className="flex-grow" style={{marginRight: 10}}>
            <Input
              placeholder={t('marketing.enterNotificationTitle')}
              value={data.custom_title_en || ''}
              onChange={e =>
                setData({...data, custom_title_en: e.target.value})
              }
            />
          </div>
        </div>

        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow" style={{maxWidth: '30%'}}>
            {t('marketing.referral')}
          </div>
          <div className="" style={{marginRight: 10}}>
            <SelectType
              items={notificationTypes}
              onSelect={handleTypeSelection}
              selected={selectedType}
            />
          </div>
          <div className="flex-grow" style={{marginRight: 10}}>
            <Input
              placeholder={t('marketing.enterNotificationTitle')}
              value={data.custom_title_en || ''}
              onChange={e =>
                setData({...data, custom_title_en: e.target.value})
              }
            />
          </div>
        </div>
      </div>
      <br />
      <div>
        <div className="bg-tableHeaderBg rounded">
          <p className="uppercase text-sm px-4 py-3 text-menu">
            {t('marketing.sendCustomNotification')}
          </p>
        </div>
        <div className="flex flex-wrap justify-between items-center px-4">
          <div className="flex-grow">
            <Multiselect
              options={shopUsers}
              onSelect={onSelectUser}
              onRemove={onRemoveUser}
              displayValue="name"
              placeholder={t('marketing.selectUsers')}
              style={{
                inputField: {
                  margin: 0,
                  padding: 0,
                },
                searchBox: {
                  marginTop: 10,
                  pdding: 0,
                  height: 32,
                  borderColor: '#E5E7EB',
                  fontSize: 16,
                },
                multiselectContainer: {
                  margin: 0,
                  padding: 0,
                },
                chips: {
                  margin: 0,
                  padding: 2,
                  paddingLeft: 6,
                  paddingRight: 6,
                  fontSize: 14,
                  backgroundColor: '#9ac984',
                },
                option: {
                  padding: 4,
                  fontSize: 14,
                },
              }}
            />
          </div>
          <div
            className="mr-10"
            style={{textAlign: 'right', marginRight: -10, marginTop: 10}}>
            <Button
              onClick={() => {
                sendNotif();
              }}
              label={t('marketing.sendNotification')}
              type="primary"
            />
          </div>
        </div>

        {/* Custom Notification Fields */}
        <div className="px-4 py-4 space-y-4">
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('marketing.notificationTitleEnglish')}
              </label>
              <Input
                placeholder={
                  t('marketing.enterNotificationTitle') + ' (English)'
                }
                value={data.custom_title_en || ''}
                onChange={e =>
                  setData({...data, custom_title_en: e.target.value})
                }
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('marketing.notificationTitleSpanish')}
              </label>
              <Input
                placeholder={
                  t('marketing.enterNotificationTitle') + ' (Spanish)'
                }
                value={data.custom_title_es_mx || ''}
                onChange={e =>
                  setData({...data, custom_title_es_mx: e.target.value})
                }
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('marketing.notificationBodyEnglish')}
              </label>
              <textarea
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter notification body (English)"
                value={data.custom_body_en || ''}
                onChange={e =>
                  setData({...data, custom_body_en: e.target.value})
                }
                rows="3"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t('marketing.notificationBodySpanish')}
              </label>
              <textarea
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter notification body (Spanish)"
                value={data.custom_body_es_mx || ''}
                onChange={e =>
                  setData({...data, custom_body_es_mx: e.target.value})
                }
                rows="3"
              />
            </div>
          </div>
        </div>
      </div>
    </ContentWrapper>
  );
};

export default Marketing;
